<template>
  <div style="background: #f2f2f6; height: 100%">
        <el-table
          :data="devicelist"
          ref="table"
          stripe
              border
          height="100%"
          style="width: 100%; border-radius: 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{padding: '8px', 'text-align': 'center' }"
          class="el-table"
        >
          <template slot="empty">
                 <div>项目中还没有安装该类设备，欢迎您在添加了相关设备后进行查看。
              </div>
             </template>　
             <el-table-column prop="floorname" label="位置" >
                 <template slot-scope="scope">
                   <span> {{scope.row.floorname}}{{scope.row.roomname}}</span>
                </template>
               </el-table-column>
          <el-table-column prop="name" label="设备名称">
             <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.errmsg" placement="top" :disabled="!scope.row.errmsg">
                    <div :class="scope.row.errmsg?'el-icon-warning':''" :style="{'color':scope.row.errmsg?'red':''}">
                      {{scope.row.name}}
                    </div>
                        </el-tooltip>
                  </template>
          </el-table-column>
           <el-table-column prop="power" label="开/关">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.power"
                active-color="#13ce66"
                inactive-color="#D8D8D8"
                :disabled="!!!scope.row.online"
                :active-value="1"
                :inactive-value="0"
                @change="sendDp(scope.row,'power')"
            >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="模式">
              <template slot-scope="scope">
                   <el-select
                   style="max-width:120px"
                   v-if="scope.row.dplist.filter(d=>{return d.name=='acmode'}).length>0"
                size="mini"
                v-model="scope.row.acmode"
                
                :disabled="!!!scope.row.online||!!!scope.row.power"
                @change="sendDp(scope.row, 'acmode')"
              >
                <el-option
                  v-for="item in getSelectItem(scope.row, 'acmode')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
                <el-select
                 style="max-width:120px"
                   v-else-if="scope.row.dplist.filter(d=>{return d.name=='mode'}).length>0"
                size="mini"
                v-model="scope.row.mode"
                
                :disabled="!!!scope.row.online||!!!scope.row.power"
                @change="sendDp(scope.row, 'mode')"
              >
                <el-option
                  v-for="item in getSelectItem(scope.row, 'mode')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              </template>
          </el-table-column>
          <el-table-column prop="model" label="设定温度">
            <template slot-scope="scope">
                <el-input-number
                size="mini"
                 style="max-width:120px"
                v-model="scope.row.settemp"
                :min="getDpAttr(scope.row, 'settemp', 'min')"
                :max="getDpAttr(scope.row, 'settemp', 'max')"
                :step="getDpAttr(scope.row, 'settemp', 'step')"
                label="设定温度"
                :disabled="!!!scope.row.online||!!!scope.row.power"
                @change="sendDp(scope.row, 'settemp')"
              ></el-input-number>
            </template>
          </el-table-column>
         <el-table-column
            prop="temp"
            label="房间温度"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.temp||'-' }}℃</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="filterAused"
            label="风速"
          >
           <template slot-scope="scope">
              <el-select
                   v-show="scope.row.dplist.filter(d=>{return d.name=='fanset'}).length>0&&scope.row.mode!=20"
                size="mini"
                 style="max-width:100px"
                v-model="scope.row.fanset"
                
                :disabled="!!!scope.row.online||!!!scope.row.power"
                @change="sendDp(scope.row, 'fanset')"
              >
                <el-option
                  v-for="item in getSelectItem(scope.row, 'fanset')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
           </template>
          </el-table-column>
          <el-table-column
            prop="online"
            label="在线&故障"
            >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.online === 1 ? color='success' : 'danger'"
                disable-transitions
                >{{ scope.row.online ? "在线" : "离线" }}</el-tag
              >
               <el-tag
                :type="scope.row.errorcode ? color='danger' : 'success'"
                disable-transitions
                >{{ scope.row.errorcode ? "故障" : "正常" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="更多">
             <template slot-scope="scope">
                  <el-button type="text" @click="showMore(scope.row)">更多参数</el-button>
             </template>
          </el-table-column>
        </el-table>

         <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :modal="false"
      :show-close="false"
      :withHeader="false"
      :before-close="handleClose"
      style=" position:absolute;"
    >
    <el-table  :data="dplist"
          ref="dptable"
          stripe border
          height="99%"
          style="width: 100%; border-radius: 10px;"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{padding: '5px', 'text-align': 'left' }"
          class="el-table">
         
  <el-table-column
            prop="desc"
            label="设备参数"
          >
             <template slot-scope="scope">
               {{scope.row.desc}}<span v-if="(scope.row.xrw==1||scope.row.xrw==3)&&scope.row.type==2">({{scope.row.unit}})</span>
             </template>
          
          </el-table-column>
           <el-table-column
            prop="desc"
            label=""
          >
              <template slot-scope="scope">
             <span v-if="scope.row.xrw==2&&scope.row.type==2">{{selectRow[scope.row.name]}}{{scope.row.unit}}</span>
             <span v-else-if="scope.row.xrw==2&&scope.row.type==1">{{getDpText(selectRow,scope.row.name)}}</span>
              <el-input-number
                v-else-if="(scope.row.xrw==1||scope.row.xrw==3)&&scope.row.type==2"
                size="mini"
                v-model="selectRow[scope.row.name]"
                :min="getDpAttr(selectRow, scope.row.name, 'min')"
                :max="getDpAttr(selectRow, scope.row.name, 'max')"
                :step="getDpAttr(selectRow, scope.row.name, 'step')"
                :label="scope.row.desc"
                :disabled="!!!selectRow.online||!!!selectRow.power"
                @change="sendDp(selectRow, scope.row.name)"
              ></el-input-number>
               <el-select
                v-else-if="(scope.row.xrw==1||scope.row.xrw==3)&&scope.row.type==1"
                size="mini"
                v-model="selectRow[scope.row.name]"
                
                :disabled="!!!selectRow.online||!!!selectRow.power"
                @change="sendDp(selectRow, scope.row.name)"
              >
                <el-option
                  v-for="item in getSelectItem(selectRow, scope.row.name)"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
    </el-table>
    </el-drawer>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Aircondition',
  data () {
    return {
      drawer: false,
      tabledate: [],
      selectRow: {},
      temp:0
    }
  },
  watch:{
  },
  computed: {
    devicelist () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'aricondition' })
    },
    dplist () {
      if (this.selectRow.innerid) {
        return this.selectRow.dplist.filter(d => { return d.xrw != 4 && ['power', 'acmode','mode', 'temp', 'settemp','fanset'].indexOf(d.name) == -1 })
      } else {
        return []
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    getSelectItem (device, tag) {
      let dp = device.dplist.filter((d) => { return d.name == tag })
      let Text = []
      if (dp && dp.length > 0) {
        if(dp[0].cfgmap) {
          let tagCfg = device[tag + 'cfg']
          for(let i=0; i<dp[0].text.length; i++) {
            if(tagCfg & (1<<i)) {
              let dpText = dp[0].options.filter((x) => {
                return x.text == JSON.parse(dp[0].text)[i]
              })
              if(dpText[0]){
                Text.push(dpText[0])
              }
              
            }
          }
          console.log(Text.length,tag)
          return Text
        }else {
          return dp[0].options
        }
        // return dp[0].options
      } else {
        return []
      }
    },
    sendDp (device, tag) {
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
        let msg = {
          devdpmsg: {
            devid: device.deviceid,
            dpid: dp[0].dpid,
            data: device[tag]
          }
        }
        this.Common.mqttSend(device.srcaddress, msg)
      }
    },
    getDpAttr (device, tag, value) {
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
        return dp[0][value] || 0
      } else {
        return 0
      }
    },
    showMore (device) {
      this.drawer = true
      this.selectRow = device
    },
    getDpText(device,tag){
      let dp = device.dplist.filter(d => { return d.name == tag })
      if (dp && dp.length > 0) {
          if(dp[0].type==1){
            let o= dp[0].options.filter(o=>{return o.value==device[tag]})
            if(o&&o.length>0){
              return o[0].text;
            }else{
              return device[tag]
            }
          }else{
            return device[tag];
          }
         
      } else {
        return ''
      }
    },
    handleClose () {
      this.drawer = false
      this.selectRow = {}
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-main{
  position: relative;
}
.del-drawer{
  background: #f9f9f9;
}
.el-drawer:focus {
    outline: none;
}
.el-card{
width:80%;
margin-left:10%;
margin-top: 15%;
height:80%
}

.allcontrol{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 5px;
}

.allcontrolimg{
  width:40px;
  height:40px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.allcontrolimg_small{
  margin-top: 5px;
  width:20px;
  height:20px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.el-table__row .el-table_1_column_5   {
  color: crimson;
}
.bb {
  position: relative;
}
.aa {

  position: absolute;
  top: 0px;
  width: 200px;
  text-align: left;
  z-index:9999;
}
.el-table >>> .el-checkbox__input {
  margin-left: 40px;
}
.el-table >>> .cell {
  padding: 0;
}
/* .el-table >>> .el-table__column-filter-trigger {
  margin-right: 30px;
}
.el-table >>> .el-tag.el-tag--success {
  margin-right: 30px;
} */

</style>



// WEBPACK FOOTER //
// src/components/Devices/Aircondition.vue